(function () {
  function init() {
    document.querySelectorAll('.mthr-product-layout').forEach(function (layout) {
      if (layout.dataset.scrollReady) return;
      layout.dataset.scrollReady = 'true';
      var panel = layout.querySelector('.mthr-foundation-info, .product__info-container');
      if (!panel) return;
      panel.style.setProperty('--mthr-panel-top', '110px');
    });
    // Escape section stacking contexts created by the scrolling hero treatment.
    document.querySelectorAll('.shopify-section [data-mthr-purchase-bar]').forEach(function (item) {
      var owner = item.closest('.shopify-section');
      item.dataset.ownerSection = owner.id;
      document.body.appendChild(item);
    });
    var bar = document.querySelector('[data-mthr-purchase-bar]');
    var section = document.getElementById('foundation-teaser') || document.querySelector('.mthr-pdp-surface');
    var addToCart = section && section.querySelector('.formthr-buy-box__atc');
    if (bar && addToCart && !bar.dataset.ready) {
      bar.dataset.ready = 'true';
      var cta = bar.querySelector('.mthr-purchase-bar__cta');
      if (cta) cta.addEventListener('click', function (event) {
        var target = document.getElementById(cta.getAttribute('href').slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
      });
      var scheduled = false;
      function update() {
        scheduled = false;
        // Stay visible across all sections once the main button has passed the top.
        bar.hidden = addToCart.getBoundingClientRect().bottom > 0;
      }
      window.addEventListener('scroll', function () {
        if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
      }, {passive:true});
      window.addEventListener('resize', update);
      new ResizeObserver(update).observe(section);
      update();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    document.querySelectorAll('[data-mthr-purchase-bar]').forEach(function (bar) {
      if (bar.dataset.ownerSection === event.target.id) bar.remove();
    });
  });
})();
